export var getDiscountStatus = function (price, accessoryPrices, servicesPrices) {
    if (!price) {
        return false;
    }
    var isProductDiscounted = isDiscounted(price);
    if (isProductDiscounted) {
        return true;
    }
    if ((accessoryPrices === null || accessoryPrices === void 0 ? void 0 : accessoryPrices.length) && (accessoryPrices === null || accessoryPrices === void 0 ? void 0 : accessoryPrices.some(isDiscounted))) {
        return true;
    }
    if ((servicesPrices === null || servicesPrices === void 0 ? void 0 : servicesPrices.length) && (servicesPrices === null || servicesPrices === void 0 ? void 0 : servicesPrices.some(isDiscounted))) {
        return true;
    }
    return false;
};
var isDiscounted = function (price) {
    return price.isDiscounted
        || price.c_isDiscounted;
};
